import Layout from '@/components/layout/Layout';
import { SyncStatusCards } from '@/components/inventory/sync-report/SyncStatusCards';
import { SyncVolumeChart } from '@/components/inventory/sync-report/SyncVolumeChart';
import { SyncDetailTables } from '@/components/inventory/sync-report/SyncDetailTables';
import { UnmatchedProductsTable } from '@/components/inventory/sync-report/UnmatchedProductsTable';
import { ManualSyncTrigger } from '@/components/inventory/sync-report/ManualSyncTrigger';

export default function InventorySyncReport() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Inventory Sync Report</h1>
          <p className="text-muted-foreground">
            Monitor B2B and ChipChip data synchronization, track matching status, and trigger manual syncs
          </p>
        </div>

        <SyncStatusCards />
        <SyncVolumeChart />
        <SyncDetailTables />
        <UnmatchedProductsTable />
        <ManualSyncTrigger />
      </div>
    </Layout>
  );
}
